<template>
  <div class="receives animated fadeIn pb-8">
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <atom-spinner :animation-duration="1000" :size="80" :color="'#6200ea'" />
      <p class="primary--text font-weight-bold mt-4">
        در حال بارگذاری اطلاعات...
      </p>
    </div>

    <div v-else>
      <v-card class="common-card">
        <div>
          <h4 class="c-grey">دریافت‌ها</h4>
        </div>
        <hr class="mt-5" />
        <v-row>
          <v-col cols="12" class="d-none d-md-inline">
            <v-btn
              class="shopPrimary white--text mt-3"
              style="float: left"
              height="48"
              @click="openAddDialog()"
            >
              <v-icon class="white--text me-1"> mdi-plus-box-multiple </v-icon>
              ثبت دریافت جدید
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-block d-sm-none">
            <v-btn
              class="shopPrimary white--text mt-3"
              style="float: left"
              height="48"
              block
              @click="openAddDialog()"
            >
              <v-icon class="white--text me-1"> mdi-plus-box-multiple </v-icon>
              ثبت دریافت جدید
            </v-btn>
          </v-col>
        </v-row>
        <v-card-text>
          <div>
            <v-row class="time-row">
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <span id="dateFrom">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-month"
                    v-model="dateFrom"
                    label=" تاریخ از "
                    :editable="true"
                    class="date-input"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="dateFrom"
                  element="dateFrom"
                  color="#6200ea"
                /> </v-col
              ><v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <span id="dateTo">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-month"
                    v-model="dateTo"
                    label=" تاریخ تا "
                    :editable="true"
                    class="date-input"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="dateTo"
                  element="dateTo"
                  color="#6200ea"
                />
              </v-col>
            </v-row>
            <v-row class="time-row">
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <span id="timeFrom">
                  <v-text-field
                    outlined
                    dense
                    append-icon="mdi-clock-outline"
                    v-model="timeFrom"
                    label=" ساعت از "
                    :editable="true"
                    class="date-input"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="timeFrom"
                  element="timeFrom"
                  color="#6200ea"
                  type="time"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="6">
                <span id="timeTo">
                  <v-text-field
                    outlined
                    dense
                    append-icon="mdi-clock-outline"
                    v-model="timeTo"
                    label=" ساعت تا "
                    :editable="true"
                    class="date-input"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="timeTo"
                  element="timeTo"
                  color="#6200ea"
                  type="time"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  class="orange-borderedBtn"
                  style="float: left"
                  @click="getReceivesList"
                >
                  <v-icon class="me-1"> mdi-magnify </v-icon>
                  اعمال</v-btn
                >
              </v-col>
            </v-row>
            <hr />

            <div class="custom-input">
              <v-text-field
                outlined
                dense
                label="جستجو..."
                v-model="Filter"
                color="#6200ea"
                prepend-inner-icon="$Search"
              ></v-text-field>
            </div>
            <div
              v-if="!loaded1"
              class="d-flex flex-column align-items-center mt-8 py-6"
            >
              <atom-spinner
                :animation-duration="1000"
                :size="80"
                :color="'#6200ea'"
              />
              <p class="primary--text font-weight-bold mt-4">
                در حال بارگذاری اطلاعات...
              </p>
            </div>
            <div v-else class="custom-table">
              <b-table
                responsive
                show-empty
                :fields="Fields"
                :items="receives"
                empty-text="در بازه زمانی انتخاب شده دریافتی ثبت نشده‌ است"
                empty-filtered-text="در بازه زمانی انتخاب شده دریافتی ثبت نشده‌ است"
                :filter="Filter"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                striped
                thead-class="headClass"
                tbody-class="bodyClass"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(isRefunded)="data">
                  <div
                    style="text-align: center; vertical-align: middle"
                    :class="data.value ? 'red--text' : 'green--text'"
                  >
                    {{ data.value ? "استرداد" : "دریافت" }}
                  </div>
                </template>
                <template v-slot:cell(amount)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ Number(data.value).toLocaleString() }}
                  </div>
                </template>
                <template v-slot:cell(transactionFee)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{
                      data.item.transferType == "کارت" ||
                      data.item.transferType == "چک"
                        ? Number(data.value).toLocaleString()
                        : "-"
                    }}
                  </div>
                </template>
                <template v-slot:cell(description)="data">
                  <div v-if="data.value.length > 10">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attr }">
                        <span v-on="on" v-bind="attr">
                          {{ data.value.slice(0, 10) }} </span
                        ><span>...</span>
                      </template>
                      <div>
                        <span>
                          {{ data.value }}
                        </span>
                      </div>
                    </v-tooltip>
                  </div>
                  <div v-else>{{ data.value }}</div>
                </template>
                <template v-slot:cell(operation)="row">
                  <div
                    style="text-align: center; vertical-align: middle"
                    class="pt-0"
                  >
                    <v-btn
                      v-if="!row.item._showDetails"
                      @click="row.toggleDetails"
                      class="orange-mainBtn"
                      width="120"
                      >نمایش عملیات</v-btn
                    >
                    <v-btn
                      v-else
                      @click="row.toggleDetails"
                      class="red-mainBtn"
                      width="120"
                      >بستن عملیات</v-btn
                    >
                  </div>
                </template>
                <template #row-details="row">
                  <div
                    class="animated fadeIn mb-2"
                    style="text-align: center; vertical-align: middle"
                  >
                    <!-- <v-btn
                      class="blue-mainBtn mx-2"
                      width="155"
                      height="40"
                      @click="onRowSelected(row.item) & openEditDialog()"
                      ><v-icon class="me-1">mdi-pencil-box-outline</v-icon>
                      ویرایش</v-btn
                    > -->
                    <v-btn
                      class="green-mainBtn mx-2"
                      width="155"
                      height="40"
                      @click="onRowSelected(row.item)"
                      ><v-icon class="me-1">mdi-note</v-icon>مشاهده
                      جزییات</v-btn
                    >
                    <v-btn
                      v-if="!row.item.isRefunded"
                      class="orange-mainBtn pa-2 ms-2"
                      @click="openModal(row.item)"
                      width="155"
                      height="40"
                      ><v-icon>mdi-cash</v-icon>
                      استرداد
                    </v-btn>
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + perPage * (currentPage - 1) + 1 }}
                  </div>
                </template>
                <div slot="table-busy" class="text-center primary--text my-2">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    class="align-middle"
                  ></v-progress-circular>
                </div>
              </b-table>
              <v-row class="mt-6">
                <v-col>
                  <div class="d-flex flex-row">
                    <span class="c-grey pt-2">نمایش در هر صفحه</span>
                    <div class="ms-3 me-3 number-box">
                      <v-select
                        outlined
                        v-model="perPage"
                        :items="perPageItems"
                        @change="currentPage = 1"
                      >
                      </v-select>
                    </div>
                  </div>
                </v-col>
                <v-col class="d-flex flex-row">
                  <span class="c-grey pt-2"> برو به صفحه </span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      outlined
                      v-model="whichPage"
                      type="number"
                      @change="goToPage()"
                      @click="goToPage()"
                      :items="computedIndex"
                    ></v-select>
                  </div>
                </v-col>
                <v-col class="text-sm-center">
                  <div>
                    <v-pagination
                      v-model="currentPage"
                      prev-icon="$ArrowLeft"
                      next-icon="$ArrowRight"
                      :length="Math.ceil(receives.length / perPage)"
                      :total-visible="5"
                      class="float-sm-end"
                    >
                    </v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          
          </div>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="addReceiveItemDialog" width="600">
      <v-card>
        <v-card-title class="white"
          ><v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                ثبت دریافتی جدید
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="cancelAddReceive()"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row></v-card-title
        >
        <hr class="mt-0 pt-0" />
        <v-card-text class="pb-0 mb-0">
          <v-select
            v-model="receiveDetail.userId"
            :items="allUsers"
            item-text="name"
            item-value="id"
            label="نام شخص"
            outlined
            dense
          ></v-select>
          <vuetify-money
            v-model="receiveDetail.amount"
            label="مبلغ (تومان)"
            :valueWhenIsEmpty="whenIsEmpty"
            :options="vMoneyOptions"
            type="number"
            outlined
            dense
          ></vuetify-money>
          <v-row class="time-row">
            <v-col cols="12">
              <span id="newDate">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-calendar-month"
                  v-model="receiveDetail.newDate"
                  label=" تاریخ "
                  :editable="true"
                  class="date-input"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="receiveDetail.newDate"
                element="newDate"
                color="#6200ea"
              /> </v-col
            ><v-col cols="12">
              <span id="newTime">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-clock-outline"
                  v-model="receiveDetail.newTime"
                  label=" ساعت"
                  :editable="true"
                  class="date-input"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="receiveDetail.newTime"
                element="newTime"
                type="time"
                color="#6200ea"
              />
            </v-col>
          </v-row>
          <v-row class="time-row">
            <v-col>
              <v-select
                v-model="receiveDetail.transferType"
                :items="receiveTypes"
                item-text="text"
                item-value="value"
                label="نحوه دریافت"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>

          <v-row
            v-if="
              receiveDetail.transferType == 'card' ||
              receiveDetail.transferType == 'cheque'
            "
          >
            <v-col class="pb-0">
              <div v-if="receiveDetail.transferType == 'card'">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="receiveDetail.cardNumberSender"
                  label="شماره کارت فرستنده "
                  @wheel="$event.target.blur()"
                >
                </v-text-field>
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="receiveDetail.cardNumberReciever"
                  label="شماره کارت گیرنده "
                  @wheel="$event.target.blur()"
                >
                </v-text-field>
              </div>
              <div v-if="receiveDetail.transferType == 'cheque'">
                <v-text-field
                  outlined
                  dense
                  v-model="receiveDetail.chequeBankName"
                  label="نام بانک "
                >
                </v-text-field>
                <vuetify-money
                  v-model="receiveDetail.chequeAmount"
                  label="مبلغ چک (تومان)"
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="vMoneyOptions"
                  type="number"
                  outlined
                  dense
                ></vuetify-money>
                <v-text-field
                  outlined
                  dense
                  v-model="receiveDetail.chequeNumber"
                  label="شماره چک"
                >
                </v-text-field>
                <v-text-field
                  outlined
                  dense
                  v-model="receiveDetail.chequeSayyad"
                  label="شناسه صیاد"
                >
                </v-text-field>
                <span id="newCheque">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-month"
                    v-model="receiveDetail.chequeNewDate"
                    label=" تاریخ چک"
                    :editable="true"
                    class="date-input"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="receiveDetail.chequeNewDate"
                  element="newCheque"
                  color="#6200ea"
                />
                <v-row class="time-row mb-4">
                  <v-col>
                    <v-select
                      v-model="receiveDetail.chequeStatus"
                      :items="chequeStatuses"
                      item-text="text"
                      item-value="value"
                      label="وضعیت چک"
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
                <v-textarea
                  outlined
                  dense
                  type="text"
                  v-model="receiveDetail.chequeDescription"
                  label=" توضیحات چک"
                >
                </v-textarea>
              </div>
            </v-col>
          </v-row>
          <div
            :class="
              receiveDetail.transferType == 'cash' ||
              receiveDetail.transferType == 'pos' ||
              !receiveDetail.transferType
                ? 'mt-5'
                : 'mt-2'
            "
          >
            <vuetify-money
              v-model="receiveDetail.transactionFee"
              label="کارمزد انتقال وجه (تومان)"
              :valueWhenIsEmpty="whenIsEmpty"
              :options="vMoneyOptions"
              type="number"
              outlined
              dense
              v-if="
                receiveDetail.transferType == 'card' ||
                receiveDetail.transferType == 'cheque'
              "
            ></vuetify-money>
            <p class="text-right mb-2">
              * شما می‌توانید بیش از یک فایل انتخاب کنید.
            </p>
            <v-file-input
              @change="myUpload(receiveDetail.file)"
              v-model="receiveDetail.file"
              chips
              outlined
              dense
              label="بارگذاری فایل"
              prepend-inner-icon="mdi-folder-multiple"
              prepend-icon=""
              class="file-input"
            ></v-file-input>
            <v-progress-linear
              rounded
              v-if="myFile.showProgress"
              height="10"
              :value="myFile.uploadPercentage"
              class="mb-4 mt-0"
            >
            </v-progress-linear>
          </div>
          <v-row>
            <div
              v-if="myFile.isUploaded"
              color="green"
              class="my-2 px-3"
              style="font-size: 16px"
            >
              فایل با موفقیت بارگذاری شد.
            </div>
          </v-row>
          <div v-if="uploadedFiles.length" class="files-box d-flex flex-column">
            <div class="files-title">
              فایل‌های آپلود شده ({{ uploadedFiles.length }})
            </div>
            <span
              v-for="(item, index) in uploadedFiles"
              :key="index"
              class="mb-2 pt-2"
            >
              <span @click="deleteFile(index)" class="pointer">
                <v-icon class="red--text text--lighten-1 pe-2"
                  >mdi-close-circle-outline</v-icon
                >
              </span>
              <a :href="item.url" target="blank">{{ showName[index] }}</a>
            </span>
          </div>
          <v-textarea
            v-model="receiveDetail.description"
            label="توضیحات"
            outlined
            dense
            class="mt-5"
          ></v-textarea>
          <div class="text-left pe-3 pb-4 pt-0">
            <v-btn
              class="green-mainBtn me-3"
              :disabled="computedAddBtn"
              @click="addToReceiveList()"
            >
              تایید
            </v-btn>
            <v-btn class="red-mainBtn" @click="cancelAddReceive()">
              بستن
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="receiveItemDialog" width="600">
      <v-card
        
        v-if="!edited"
   
      >
       <v-card-title class="white"
          ><v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                مشاهده جزییات دریافت
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="receiveItemDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row></v-card-title
        >
        <hr class="mt-0 pt-0" />

        <v-card-text>
          <v-row class="mt-3">
            <v-col v-if="selected.userName">
              <span class="primary--text">نام کارمند:</span>
              <span> {{ selected.userName }}</span>
            </v-col>
            <v-col v-if="selected.patientName">
              <span class="primary--text">نام بیمار:</span>
              <span> {{ selected.patientName }}</span>
            </v-col>
            <v-col>
              <span class="primary--text">مبلغ :</span>
              <span> {{ Number(selected.amount).toLocaleString() }} تومان</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="primary--text">تاریخ دریافت:</span>
              <span> {{ selected.date }}</span>
            </v-col>
            <v-col>
              <span class="primary--text">ساعت دریافت :</span>
              <span> {{ selected.time }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-2">
              <span class="primary--text">نحوه دریافت :</span>
              <span> {{ selected.transferType }}</span>
            </v-col>
          </v-row>
          <v-row
            v-if="
              selected.transferType == 'کارت' || selected.transferType == 'چک'
            "
          >
            <v-col>
              <div
                v-if="selected.transferType == 'کارت'"
                class="cardInfo-box ps-2 py-2 d-flex flex-column"
              >
                <div>
                  <span class="primary--text">شماره کارت فرستنده :</span>
                  <span class="float-end" dir="ltr">
                    {{ cardNumberSpacer(selected.cardNumberSender) }}</span
                  >
                </div>
                <div class="mt-5">
                  <span class="primary--text">شماره کارت گیرنده :</span>
                  <span class="float-end" dir="ltr">
                    {{ cardNumberSpacer(selected.cardNumberReciever) }}</span
                  >
                </div>
              </div>
              <div
                v-if="selected.transferType == 'چک'"
                class="cardInfo-box ps-2 py-2 d-flex flex-column"
              >
                <div>
                  <span class="primary--text">نام بانک :</span>
                  <span> {{ selected.chequeBankName }}</span>
                </div>
                <div class="mt-5">
                  <span class="primary--text">مبلغ چک :</span>
                  <span>
                    {{ Number(selected.chequeAmount).toLocaleString() }}
                    تومان</span
                  >
                </div>
                <div class="mt-5">
                  <span class="primary--text">شماره چک :</span>
                  <span> {{ selected.chequeNumber }}</span>
                </div>
                <div class="mt-5">
                  <span class="primary--text">شناسه صیاد :</span>
                  <span>
                    {{
                      selected.chequeSayyad ? selected.chequeSayyad : "--"
                    }}</span
                  >
                </div>
                <div class="mt-5">
                  <span class="primary--text">تاریخ چک :</span>
                  <span> {{ selected.chequeDueDate }}</span>
                </div>
                <div class="mt-5">
                  <span class="primary--text">وضعیت چک :</span>
                  <span> {{ selected.chequeStatus }}</span>
                </div>
                <div class="mt-5">
                  <span class=" primary--text">توضیحات چک :</span>
                  <div
                    
                    style="line-height: 22px; text-align: justify"
                  >
                    {{
                      selected.chequeDescription
                        ? selected.chequeDescription
                        : "توضیحی ثبت نشده است."
                    }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row
            v-if="
              selected.transferType == 'کارت' || selected.transferType == 'چک'
            "
          >
            <v-col>
              <span class="primary--text">کارمزد انتقال وجه:</span>
              <span>
                {{ Number(selected.transactionFee).toLocaleString() }} تومان
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="selected.files">
              <span class="primary--text">
                فایل‌ها ({{ selected.files.length }}):</span
              >
              <!-- قسمت مربوط به فایل (لینک فایل گرفته شود) -->
              <span v-if="!selected.files.length" style="font-size: 15px">
                --
              </span>
              <div class="d-flex flex-column mt-1 ps-5">
                <ul>
                  <li
                    v-for="(item, index) in selected.files"
                    :key="index"
                    class="pt-5"
                    style="font-size: 15px"
                  >
                    <a :href="item.url" target="blank">{{
                      item.name.length > 50
                        ? item.name.slice(0, 50) + "..."
                        : item.name
                    }}</a>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="selected.title">
            <v-col>
              <span class="primary--text">دریافت بابت :</span>

              <div class="mt-1" style="line-height: 22px; text-align: justify">
                {{ selected.title }}
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="primary--text">توضیحات :</span>

              <div class="mt-1" style="line-height: 22px; text-align: justify">
                {{ selected.description }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-btn @click="openEditDialog()" class="secondary-btn mb-4 me-5 pa-5">
          <v-icon left>edit</v-icon>
          ویرایش</v-btn
        > -->
      </v-card>
      <v-card
        class="modal-card"
        v-else
        style="
          max-height: 600px !important;
          overflow-y: auto;
          overflow-x: hidden;
        "
      >
        <v-card-title class="mb-2">
          <h4>ویرایش دریافت</h4>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-3 time-row">
            <v-col>
              <div
                class="disabled-fields grey lighten-3"
                v-if="selectedEdit.userName"
              >
                <span> نام کارمند: {{ selectedEdit.userName }}</span>
              </div>

            </v-col>
            <v-col>
              <vuetify-money
                v-model="selectedEdit.amount"
                label="مبلغ (تومان)"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                type="number"
                outlined
                dense
              ></vuetify-money>
            </v-col>
          </v-row>
          <v-row class="time-row">
            <v-col>
              <span id="newDate2">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-calendar-month"
                  v-model="selectedEdit.date"
                  label=" تاریخ "
                  :editable="true"
                  class="date-input"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="selectedEdit.date"
                element="newDate2"
                color="#6200ea"
              /> </v-col
            ><v-col>
              <span id="newTime2">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-clock-outline"
                  v-model="selectedEdit.time"
                  label=" ساعت "
                  :editable="true"
                  class="date-input"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="selectedEdit.time"
                element="newTime2"
                type="time"
                color="#6200ea"
              />
            </v-col>
          </v-row>
          <v-row class="time-row">
            <v-col
              ><v-select
                v-model="selectedEdit.transferType"
                :items="receiveTypes"
                item-text="text"
                item-value="value"
                label="نحوه دریافت"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>

          <v-row
            class="time-row"
            v-if="
              selectedEdit.transferType == 'card' ||
              selectedEdit.transferType == 'cheque'
            "
          >
            <v-col>
              <div v-if="selectedEdit.transferType == 'card'">
                <v-text-field
                  outlined
                  dense
                  type="number"
                  class="mb-4"
                  v-model="selectedEdit.cardNumberSender"
                  label="شماره کارت فرستنده "
                  @wheel="$event.target.blur()"
                >
                </v-text-field>
                <v-text-field
                  outlined
                  dense
                  type="number"
                  v-model="selectedEdit.cardNumberReciever"
                  label="شماره کارت گیرنده "
                  @wheel="$event.target.blur()"
                >
                </v-text-field>
              </div>

              <div v-if="selectedEdit.transferType == 'cheque'">
                <v-text-field
                  outlined
                  dense
                  v-model="selectedEdit.chequeBankName"
                  label="نام بانک "
                  class="mb-4"
                >
                </v-text-field>
                <vuetify-money
                  v-model="selectedEdit.chequeAmount"
                  label="مبلغ چک (تومان)"
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="vMoneyOptions"
                  type="number"
                  outlined
                  dense
                  class="mb-4"
                ></vuetify-money>
                <v-text-field
                  outlined
                  dense
                  v-model="selectedEdit.chequeNumber"
                  label="شماره چک"
                  class="mb-4"
                >
                </v-text-field>
                <v-text-field
                  outlined
                  dense
                  v-model="selectedEdit.chequeSayyad"
                  label="شناسه صیاد"
                  class="mb-4"
                >
                </v-text-field>
                <span id="newChequeDate">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-month"
                    v-model="selectedEdit.chequeDueDate"
                    label=" تاریخ چک"
                    :editable="true"
                    class="date-input mb-4"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="selectedEdit.chequeDueDate"
                  element="newChequeDate"
                  color="#6200ea"
                />
                <v-row class="time-row mb-4">
                  <v-col
                    ><v-select
                      v-model="selectedEdit.chequeStatus"
                      :items="chequeStatuses"
                      item-text="text"
                      item-value="value"
                      label="وضعیت چک"
                      outlined
                      dense
                    ></v-select>
                  </v-col>
                </v-row>
                <v-textarea
                  outlined
                  dense
                  type="text"
                  v-model="selectedEdit.chequeDescription"
                  label=" توضیحات چک"
                >
                </v-textarea>
              </div>
            </v-col>
          </v-row>
          <v-row
            class="time-row"
            v-if="
              selectedEdit.transferType == 'cheque' ||
              selectedEdit.transferType == 'card'
            "
          >
            <v-col>
              <vuetify-money
                v-model="selectedEdit.transactionFee"
                label="کارمزد انتقال وجه (تومان)"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                type="number"
                outlined
                dense
              ></vuetify-money>
            </v-col>
          </v-row>
          <v-row class="time-row">
            <v-col>
              <p class="text-right mb-2 h6">
                * شما می‌توانید بیش از یک فایل انتخاب کنید.
              </p>
              <v-file-input
                @change="editedUpload(file)"
                v-model="file"
                chips
                outlined
                dense
                label=" بارگذاری فایل"
                prepend-inner-icon="mdi-folder-multiple"
                prepend-icon=""
                class="file-input mb-6"
              ></v-file-input>
              <v-progress-linear
                rounded
                v-if="myFile.showProgress"
                height="10"
                :value="myFile.uploadPercentage"
                class="mb-4 mt-0"
              >
              </v-progress-linear>
              <v-row>
                <div
                  v-if="myFile.isUploaded"
                  color="green"
                  class="mt-3 mb-1 pa-3"
                  style="font-size: 16px"
                >
                  فایل با موفقیت بارگذاری شد.
                </div>
              </v-row>
            </v-col>
          </v-row>
          <div
            v-if="selectedEdit.files.length"
            class="files-box d-flex flex-column mb-6"
          >
            <div class="files-title">
              فایل‌های آپلود شده ({{ selectedEdit.files.length }})
            </div>
            <span
              v-for="(item, index) in selectedEdit.files"
              :key="index"
              class="mb-2 pt-2"
            >
              <span @click="deleteFile2(index)" class="pointer">
                <v-icon class="red--text text--lighten-1 pe-2"
                  >mdi-close-circle-outline</v-icon
                >
              </span>
              <a :href="item.url" target="blank">{{ item.name }}</a>
            </span>
          </div>
          <v-row class="time-row">
            <v-col>
              <v-textarea
                v-model="selectedEdit.description"
                label="توضیحات"
                outlined
                dense
              ></v-textarea>
            </v-col>
          </v-row>

          <v-btn
            :disabled="computedEditBtn"
            @click="editReceiveItem()"
            class="primary-btn mt-4 mx-2"
            >ثبت</v-btn
          >
          <v-btn
            @click="
              edited = false;
              uploadedFiles = [];
              myFile.isUploaded = false;
              myFile.showProgress = false;
            "
            class="red-btn mt-4"
            >لغو</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="refundDialog" width="600px">
      <v-card>
        <v-card-title class="white"
          ><v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                بازپرداخت
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="cancelRefundReceive()"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row></v-card-title
        >
        <hr class="mt-0 pt-0" />
        <v-card-text class="pb-0">
          <h6 class="text-right">
            <span>
              شما در حال بازپرداخت مبلغ:
              {{ Number(selectedRefund.amount).toLocaleString() }} تومان
              هستید.</span
            >
          </h6>
          <v-row class="time-row mt-3">
            <v-col
              ><v-select
                v-model="selectedRefund.transferType"
                :items="receiveTypes"
                item-text="text"
                item-value="value"
                label="نحوه پرداخت"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
          <v-row
            class="time-row"
            v-if="
              selectedRefund.transferType == 'card' ||
              selectedRefund.transferType == 'cheque'
            "
          >
            <v-col>
              <div v-if="selectedRefund.transferType == 'card'">
                <div
                  style="border: 1px grey solid; border-radius: 8px"
                  class="px-3 py-2"
                >
                  <h5>اطلاعات کارت‌ها</h5>
                  <v-text-field
                    outlined
                    dense
                    type="number"
                    class="mb-4"
                    v-model="selectedRefund.cardNumberSender"
                    label="شماره کارت فرستنده*"
                  >
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    type="number"
                    v-model="selectedRefund.cardNumberReciever"
                    label="شماره کارت گیرنده*"
                  >
                  </v-text-field>
                  <vuetify-money
                    v-model="selectedRefund.transactionFee"
                    label="کارمزد انتقال وجه (تومان)"
                    :valueWhenIsEmpty="whenIsEmpty"
                    :options="vMoneyOptions"
                    type="number"
                    outlined
                    dense
                    class="mt-5"
                  ></vuetify-money>
                </div>
              </div>

              <div v-if="selectedRefund.transferType == 'cheque'">
                <div
                  style="border: 1px grey solid; border-radius: 8px"
                  class="px-3 py-2"
                >
                  <h5>اطلاعات چک</h5>
                  <vuetify-money
                    v-model="selectedRefund.chequeAmount"
                    label="مبلغ چک (تومان)"
                    :valueWhenIsEmpty="whenIsEmpty"
                    :options="vMoneyOptions"
                    type="number"
                    outlined
                    dense
                    class="mb-4"
                  ></vuetify-money>
                  <v-text-field
                    outlined
                    dense
                    v-model="selectedRefund.chequeBankName"
                    label="نام بانک*"
                    class="mb-4"
                  >
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    v-model="selectedRefund.chequeNumber"
                    label="شماره چک*"
                    class="mb-4"
                  >
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    v-model="selectedRefund.chequeSayyad"
                    label="شناسه صیاد"
                    class="mb-4"
                  >
                  </v-text-field>
                  <span id="newChequeDate">
                    <v-text-field
                      outlined
                      dense
                      type="text"
                      append-icon="mdi-calendar-month"
                      v-model="selectedRefund.chequeDueDate"
                      label=" تاریخ چک*"
                      :editable="true"
                      class="date-input mb-4"
                    >
                    </v-text-field>
                  </span>

                  <date-picker
                    v-model="selectedRefund.chequeDueDate"
                    element="newChequeDate"
                    color="#6200ea"
                  />
                  <v-select
                    v-model="selectedRefund.chequeStatus"
                    :items="chequeStatuses"
                    item-text="text"
                    item-value="value"
                    label="وضعیت چک"
                    outlined
                    dense
                  ></v-select>
                  <v-textarea
                    label="توضیحات چک"
                    outlined
                    dense
                    class="mt-5"
                    v-model="selectedRefund.chequeDescription"
                  >
                  </v-textarea>
                  <vuetify-money
                    v-model="selectedRefund.transactionFee"
                    label="کارمزد انتقال وجه (تومان)"
                    :valueWhenIsEmpty="whenIsEmpty"
                    :options="vMoneyOptions"
                    type="number"
                    outlined
                    dense
                    class="mt-5"
                  ></vuetify-money>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row class="time-row">
            <v-col>
              <v-file-input
                @change="refundUpload(file)"
                v-model="file"
                chips
                outlined
                dense
                label=" بارگذاری فایل"
                prepend-inner-icon="mdi-folder-multiple"
                prepend-icon=""
                class="file-input mb-6"
              ></v-file-input>
              <v-progress-linear
                rounded
                v-if="myFile2.showProgress"
                height="10"
                :value="myFile2.uploadPercentage"
                class="mb-4 mt-0"
              >
              </v-progress-linear>
              <v-row>
                <div
                  v-if="myFile2.isUploaded"
                  color="green"
                  class="my-1 pa-3"
                  style="font-size: 16px"
                >
                  فایل با موفقیت بارگذاری شد.
                </div>
              </v-row>
            </v-col>
          </v-row>
          <div
            v-if="selectedRefund.files && selectedRefund.files.length > 0"
            class="files-box d-flex flex-column mb-6"
          >
            <div class="files-title">
              فایل‌های آپلود شده ({{ selectedRefund.files.length }})
            </div>
            <span
              v-for="(item, index) in selectedRefund.files"
              :key="index"
              class="mb-2 pt-2"
            >
              <span @click="deleteRefundFile(index)" class="pointer">
                <v-icon class="red--text text--lighten-1 pe-2"
                  >mdi-close-circle-outline</v-icon
                >
              </span>
              <a :href="item.url" target="blank">{{ item.name }}</a>
            </span>
          </div>
          <v-row>
            <v-col
              ><v-textarea
                outlined
                dense
                type="text"
                v-model="refundDescription"
                label="توضیحات"
              >
              </v-textarea
            ></v-col>
          </v-row>
          <div class="text-left pe-3 pb-4 pt-0">
            <v-btn
              class="green-mainBtn me-3"
              :disabled="!refundDisabled()"
              @click="submitRefund()"
            >
              تایید
            </v-btn>
            <v-btn
              class="red-mainBtn"
              @click="cancelRefundReceive()"
              :disabled="isRefunding"
            >
              بستن
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from "axios";
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueBarcode from "vue-barcode";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    AtomSpinner,
  },
  data() {
    return {
      loaded1: false,
      loaded: true,
      allUsers: [],
      perPageItems: [5, 10, 20],
      perPage: 5,
      whichPage: 1,
      deviceType: "",
      currentPage: 1,
      perPageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      TotalRows: "",
      Filter: "",
      Busy: true,
      Fields: [
        { key: "index", label: "ردیف" },
        { key: "userName", label: "نام" },
        // { key: "role", label: "نقش" },
        { key: "amount", label: "مبلغ (تومان)" },
        { key: "date", label: "تاریخ دریافت" },
        { key: "time", label: "ساعت دریافت" },
        { key: "transferType", label: "نحوه دریافت" },
        { key: "transactionFee", label: "کارمزد انتقال وجه (تومان)" },
        { key: "fileIds", label: "تعداد فایل‌ها" },
        { key: "isRefunded", label: "وضعیت " },
        { key: "description", label: "توضیحات" },
        { key: "operation", label: "عملیات" },
      ],
      receives: [],
      dateFrom: moment(new Date()).subtract(1, "month").format("jYYYY/jMM/jDD"),
      dateTo: moment(new Date()).format("jYYYY/jMM/jDD"),
      timeFrom: "00:00",
      timeTo: "23:59",
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      role: "",
      addReceiveItemDialog: false,
      types: [
        { value: "hourly", text: "ساعتی" },
        { value: "daily", text: "روزانه" },
      ],
      states: [
        { value: "eligible", text: "استحقاقی" },
        { value: "incentive", text: "تشویقی" },
        { value: "withoutPay", text: "بدون حقوق" },
        { value: "sick", text: "استعلاجی" },
      ],
      status: [
        { value: "registered", text: "ثبت اولیه" },
        { value: "approved", text: "تایید درخواست" },
        { value: "rejected", text: "رد درخواست" },
      ],
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      reportFiles: [],
      request: {},
      vLoading: false,

      myFile: new Object({
        uploadPercentage: 0,
      }),
      myFile2: new Object({
        uploadPercentage: 0,
      }),
      fileBusy: false,
      fileFilter: "",
      receiveDetail: {
        cardNumberSender: "",
        cardNumberReciever: "",
        chequeBankName: "",
        chequeAmount: null,
        chequeNumber: "",
        chequeNewDate: "",
        chequeDescription: "",
        chequeSayyad: "",
        chequeStatus: "",
      },
      isRefunding: false,
      refundDialog: false,
      employees: [],
      employeeBusy: false,
      selected: {},
      edited: false,
      receiveItemDialog: false,
      selectedEdit: {},
      receiveTypes: [
        { text: "نقدی", value: "cash" },
        { text: "کارتخوان", value: "pos" },
        { text: "کارت", value: "card" },
        { text: "چک", value: "cheque" },
      ],
      chequeStatuses: [
        { text: "پاس شده", value: "passed" },
        { text: "برگشت خورده", value: "returned" },
        { text: "ثبت شده", value: "submitted" },
      ],
      financialId: "",
      uploadedFiles: [],
      showName: [],
      showName2: [],
      isRefunding: false,
      refundDescription: "",
      refundId: "",
      fileIds: [],
      roles: [
        {
          key: "patient",
          value: "بیمار",
        },
        {
          key: "employee",
          value: "کارمند",
        },
      ],
      selectedRefund: {
        cardNumberSender: "",
        cardNumberReciever: "",
        chequeBankName: "",
        chequeAmount: "",
        chequeNumber: "",
        chequeNewDate: "",
        chequeStatus: "",
      },
    };
  },

  methods: {
    onRowSelected(item) {
      this.financialId = item.id;
      this.uploadedFiles = [];
      this.myFile.isUploaded = false;
      this.myFile.showProgress = false;
      this.myFile.uploadPercentage = false;
      Axios.post(
        this.baseUrl + "/satrapp/financial/document/show",
        {
          financialId: this.financialId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.selected = res.data;
            this.selectedEdit = JSON.parse(JSON.stringify(this.selected));

            this.selectedEdit.transferType = this.paymentTypes.filter(
              (x) => x.text == this.selected.transferType
            )[0].value;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
      this.edited = false;
      this.receiveItemDialog = true;
    },
    getAllUsers() {
      Axios.get(
        this.baseUrl + "/satrapp/financial/document/allUsersForFinancial",
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allUsers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addToReceiveList() {
      Axios.post(
        this.baseUrl + "/satrapp/financial/document/newReceive",
        {
          date: this.receiveDetail.newDate + this.receiveDetail.newTime,
          amount: this.receiveDetail.amount,
          description: this.receiveDetail.description,
          transactionFee:
            this.receiveDetail.transferType == "card" ||
            this.receiveDetail.transferType == "cheque"
              ? this.receiveDetail.transactionFee
              : "",
          transferType: this.receiveDetail.transferType,
          chequeAmount:
            this.receiveDetail.transferType == "cheque"
              ? this.receiveDetail.chequeAmount
              : "",
          chequeNumber:
            this.receiveDetail.transferType == "cheque"
              ? this.receiveDetail.chequeNumber
              : "",
          chequeBankName:
            this.receiveDetail.transferType == "cheque"
              ? this.receiveDetail.chequeBankName
              : "",
          chequeDueDate:
            this.receiveDetail.transferType == "cheque"
              ? this.receiveDetail.chequeNewDate
              : "",
          chequeSayyad:
            this.receiveDetail.transferType == "cheque"
              ? this.receiveDetail.chequeSayyad
              : "",
          chequeStatus:
            this.receiveDetail.transferType == "cheque"
              ? this.receiveDetail.chequeStatus
              : "",
          chequeDescription:
            this.receiveDetail.transferType == "cheque"
              ? this.receiveDetail.chequeDescription
              : "",
          cardNumberSender:
            this.receiveDetail.transferType == "card"
              ? this.receiveDetail.cardNumberSender
              : "",
          cardNumberReciever:
            this.receiveDetail.transferType == "card"
              ? this.receiveDetail.cardNumberReciever
              : "",
          userId: this.receiveDetail.userId,
          fileIds: this.fileIds,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.addReceiveItemDialog = false;
            this.receiveDetail = {
              cardNumberSender: "",
              cardNumberReciever: "",
              chequeBankName: "",
              chequeAmount: "",
              chequeNumber: "",
              chequeNewDate: "",
              chequeAmount: "",
              chequeNewDate: "",
              chequeSayyad: "",
              chequeStatus: "",
            };
            this.showName = [];
            this.uploadedFiles = [];
            this.getReceivesList();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.addReceiveItemDialog = false;
            this.receiveDetail = {
              cardNumberSender: "",
              cardNumberReciever: "",
              chequeBankName: "",
              chequeAmount: "",
              chequeNumber: "",
              chequeNewDate: "",
              chequeAmount: "",
              chequeNewDate: "",
              chequeSayyad: "",
              chequeStatus: "",
            };
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.addReceiveItemDialog = false;
          this.receiveDetail = {
            cardNumberSender: "",
            cardNumberReciever: "",
            chequeBankName: "",
            chequeAmount: "",
            chequeNumber: "",
            chequeNewDate: "",
            chequeAmount: "",
            chequeNewDate: "",
            chequeSayyad: "",
            chequeStatus: "",
          };
        });
    },
    myUpload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      this.showName.push(file.name);
      formData.append(file.name, file);

      Axios.post(
        this.baseUrl + "/satrapp/financial/document/upload",
        formData,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
          onUploadProgress: ((progressEvent) => {
            this.myFile.uploadPercentage =
              Math.round((progressEvent.loaded * 100) / progressEvent.total) -
              1;
          }).bind(this),
        }
      )
        .then((d) => {
          if (d.status == 201) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles.push(d.data);
            this.fileIds.push(d.data.id);
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },
    cancelAddReceive() {
      this.addReceiveItemDialog = false;
      this.uploadedFiles = [];
      this.myFile.isUploaded = false;
      this.myFile.showProgress = false;
    },
    getReceivesList() {
      (this.loaded1 = false),
        Axios.post(
          this.baseUrl + "/satrapp/financial/documents/receives",
          {
            startDate: this.dateFrom + this.timeFrom,
            endDate: this.dateTo + this.timeTo,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              // this.toast(res.data.message, "success");
              (this.loaded1 = true), (this.receives = res.data);
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            (this.loaded1 = true), this.toast(err.response.data, "error");
          });
    },
    cardNumberSpacer(number) {
      number = number.match(new RegExp(".{1,4}", "g")).join("-");
      return number;
    },
    openAddDialog() {
      this.addReceiveItemDialog = true;
      this.receiveDetail = {
        cardNumberSender: "",
        cardNumberReciever: "",
        chequeBankName: "",
        chequeAmount: "",
        chequeNumber: "",
        chequeNewDate: "",
        chequeAmount: "",
        chequeNewDate: "",
        chequeSayyad: "",
        newDate: moment(new Date()).format("jYYYY/jMM/jDD"),
        newTime: moment(new Date()).format("HH:mm"),
      };
      this.uploadedFiles = [];
      this.myFile.isUploaded = false;
      this.myFile.showProgress = false;
      this.getAllUsers();
    },
    openEditDialog() {
      this.selected.transferType == "چک"
        ? (this.selectedEdit.chequeStatus = this.chequeStatuses.filter(
            (x) => x.text == this.selected.chequeStatus
          )[0].value)
        : "";

      this.edited = true;
    },
    openModal(item) {
      this.refundId = item.id;
      Axios.post(
        this.baseUrl + "/satrapp/financial/document/show",
        {
          financialId: this.refundId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.selectedRefund = res.data;
            this.selectedRefund.transferType = this.receiveTypes.filter(
              (x) => x.text == this.selectedRefund.transferType
            )[0].value;
            this.refundDialog = true;
            this.refundDescription =
              " استرداد دریافت به تاریخ " +
              this.selectedRefund.date +
              " و ساعت " +
              this.selectedRefund.time;
            if (this.selectedRefund.transferType == "cheque") {
              this.selectedRefund.chequeStatus = this.chequeStatuses.filter(
                (x) => x.text == this.selectedRefund.chequeStatus
              )[0].value;
            }
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    cancelRefundReceive() {
      this.refundDialog = false;
      this.uploadedFiles = [];
      this.myFile2.isUploaded = false;
      this.myFile2.showProgress = false;
    },
    deleteFile(index) {
      this.uploadedFiles.splice(index, 1);
      this.fileIds.splice(index, 1);
      this.showName.splice(index, 1);
    },
    deleteFile2(index) {
      this.selectedEdit.files.splice(index, 1);
      this.selectedEdit.fileIds.splice(index, 1);
      this.showName.splice(index, 1);
    },
    deleteRefundFile(index) {
      this.selectedRefund.files.splice(index, 1);
      this.selectedRefund.fileIds.splice(index, 1);
      this.showName2.splice(index, 1);
    },
    submitRefund() {
      this.isRefunding = true;
      Axios.post(
        this.baseUrl + "/satrapp/financial/document/refund",
        {
          financialId: this.refundId,
          transferType: this.selectedRefund.transferType,
          chequeAmount:
            this.selectedRefund.transferType == "cheque"
              ? this.selectedRefund.amount
              : "",
          chequeNumber:
            this.selectedRefund.transferType == "cheque"
              ? this.selectedRefund.chequeNumber
              : "",
          chequeBankName:
            this.selectedRefund.transferType == "cheque"
              ? this.selectedRefund.chequeBankName
              : "",
          chequeDueDate:
            this.selectedRefund.transferType == "cheque"
              ? this.selectedRefund.chequeDueDate
              : "",
          chequeSayyad:
            this.selectedRefund.transferType == "cheque"
              ? this.selectedRefund.chequeSayyad
              : "",
          chequeStatus:
            this.selectedRefund.transferType == "cheque"
              ? this.selectedRefund.chequeStatus
              : "",
          chequeDescription:
            this.selectedRefund.transferType == "cheque"
              ? this.selectedRefund.chequeDescription
              : "",
          cardNumberSender:
            this.selectedRefund.transferType == "card"
              ? this.selectedRefund.cardNumberSender
              : "",
          cardNumberReciever:
            this.selectedRefund.transferType == "card"
              ? this.selectedRefund.cardNumberReciever
              : "",
          fileIds: this.selectedRefund.fileIds,
          description: this.refundDescription,
          transactionFee: this.selectedRefund.transactionFee,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.isRefunding = false;
            this.refundDialog = false;
            this.myFile2 = new Object({
              uploadPercentage: 0,
            });
            this.showName2 = [];
            this.getReceivesList();
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.isRefunding = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },

    refundDisabled() {
      if (this.selectedRefund.transferType == "card") {
        if (
          this.selectedRefund.cardNumberSender &&
          this.selectedRefund.cardNumberReciever &&
          this.selectedRefund.transactionFee
        ) {
          return true;
        } else return false;
      } else if (this.selectedRefund.transferType == "cheque") {
        if (
          this.selectedRefund.chequeBankName &&
          this.selectedRefund.chequeNumber &&
          this.selectedRefund.chequeDueDate &&
          this.selectedRefund.chequeDescription &&
          this.selectedRefund.chequeStatus &&
          this.selectedRefund.chequeAmount &&
          this.selectedRefund.transactionFee
        ) {
          return true;
        } else return false;
      } else return true;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  computed: {
    computedIndex() {
      let arr = [];
      let computedLength = this.receives.length;
      let arrLength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrLength; i++) {
        arr.push(i);
      }
      return arr;
    },
    computedAddBtn() {
      if (
        this.receiveDetail.userId &&
        this.receiveDetail.amount &&
        this.receiveDetail.newDate &&
        this.receiveDetail.newTime &&
        this.receiveDetail.transferType &&
        this.receiveDetail.description
      ) {
        if (this.receiveDetail.transferType == "card") {
          if (
            this.receiveDetail.cardNumberSender &&
            this.receiveDetail.cardNumberReciever &&
            this.receiveDetail.transactionFee
          ) {
            return false;
          } else return true;
        } else if (this.receiveDetail.transferType == "cheque") {
          if (
            this.receiveDetail.chequeBankName &&
            this.receiveDetail.chequeAmount &&
            this.receiveDetail.chequeNumber &&
            this.receiveDetail.chequeNewDate &&
            this.receiveDetail.chequeStatus &&
            this.receiveDetail.transactionFee
          ) {
            return false;
          } else return true;
        } else return false;
      } else return true;
    },
    computedEditBtn() {
      if (
        this.selectedEdit.amount &&
        this.selectedEdit.date &&
        this.selectedEdit.time &&
        this.selectedEdit.transferType &&
        this.selectedEdit.description
      ) {
        if (this.selectedEdit.transferType == "card") {
          if (
            this.selectedEdit.cardNumberSender &&
            this.selectedEdit.cardNumberReciever &&
            this.selectedEdit.transactionFee
          ) {
            return false;
          } else return true;
        } else if (this.selectedEdit.transferType == "cheque") {
          if (
            this.selectedEdit.chequeBankName &&
            this.selectedEdit.chequeAmount &&
            this.selectedEdit.chequeNumber &&
            this.selectedEdit.chequeDueDate &&
            this.selectedEdit.chequeStatus &&
            this.selectedEdit.transactionFee
          ) {
            return false;
          } else return true;
        } else return false;
      } else return true;
    },
  },
  mounted() {
    if (window.screen.width < 950) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 950) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    this.role = localStorage.getItem("role");
    this.vLoading = true;
    this.getReceivesList();
    this.getAllUsers();
  },
};
</script>
<style lang="scss">
.receives {
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__control {
      flex-direction: row !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #6200ea !important;
    }
    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }
  }
}

.v-input__icon--append .v-icon {
  color: #6200ea;
}
.number-box {
  .v-text-field.v-text-field--enclosed .v-text-field__details,
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot {
    width: 70px !important;
    height: 34px !important;
    min-height: 34px !important;
    padding: 0 5px !important;

    .v-icon {
      transform: translateY(-12px);
      color: #6200ea;
    }

    .v-select__selection--comma {
      color: #6200ea;
    }
  }

  .v-list-item__content {
    padding: 0 !important;
  }

  .v-list-item {
    min-height: 40px !important;
  }

  .v-text-field .v-input__control,
  .v-text-field fieldset {
    border-radius: 8px !important;
    border-color: #6200ea !important;
  }

  .v-text-field__details {
    display: none !important;
  }

  input {
    text-align: center;
    color: #6200ea !important;
  }
}
.custom-table {
  .headClass {
    background-color: transparent;

    th {
      border: none !important;
      font-weight: normal !important;

      div {
        color: #4e536a;
      }
    }
  }

  .trClass {
    tr {
      &:nth-child(2n-1) {
        background-color: #f6f1fe !important;
      }

      &:nth-child(2n) {
        background-color: #ffffff !important;
      }
    }
  }

  .bodyClass {
    tr {
      border: none !important;
      height: 60px !important;

      &:nth-child(2n) {
        background-color: #ffffff !important;
      }

      td {
        border: none !important;
        text-align: center !important;

        div {
          padding-top: 5px;
        }

        &:nth-child(1) {
          border-top-right-radius: 8px !important;
          border-bottom-right-radius: 8px !important;
        }

        &:last-child {
          border-top-left-radius: 8px !important;
          border-bottom-left-radius: 8px !important;
        }
      }
    }
  }

  .number-box {
    .v-text-field.v-text-field--enclosed .v-text-field__details,
    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
      > .v-input__control
      > .v-input__slot {
      width: 70px !important;
      height: 34px !important;
      min-height: 34px !important;
      padding: 0 5px !important;

      .v-icon {
        transform: translateY(-12px);
        color: #6200ea;
      }

      .v-select__selection--comma {
        color: #6200ea;
      }
    }

    .v-list-item__content {
      padding: 0 !important;
    }

    .v-list-item {
      min-height: 40px !important;
    }

    .v-text-field .v-input__control,
    .v-text-field fieldset {
      border-radius: 8px !important;
      border-color: #6200ea !important;
    }

    .v-text-field__details {
      display: none !important;
    }

    input {
      text-align: center;
      color: #6200ea !important;
    }
  }
}
</style>
